import React, { Component } from "react";
import "./LinkButton.css";

class LinkButton extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { linkButton } = this.props;
    const { text, url, isOpenInNewWindow } = linkButton;

    return (
      <a href={url} target={isOpenInNewWindow ? "_blank" : "_self"}>
        <div className="link-button-container">
          <span className="text">{text}</span>
        </div>
      </a>
    );
  }
}

export default LinkButton;
